import { gql } from '@apollo/client'
import { path, find, prop } from 'ramda'

import { useLoggedUser } from '@btime/react-session'
import { accountsClient } from '../apollo/api'
import { useQuery } from '../apollo/_helpers/useQuery'

const QUERY = gql`
  query LoggedUserSignature($filter: UserFilter) {
    users(filter: $filter) {
      id
      contract {
        id
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
    }
  }
`

const SIGNATURE_FIELD_TYPES = ['signature', 'sign']

const parseValue = raw => {
  if (raw == null) return null
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw)
    } catch {
      return null
    }
  }
  return raw
}

const normalizeSignatureValue = value => {
  if (!value || typeof value !== 'object') return null
  const doc = value.document || value
  const documentId = value.documentId ?? doc?.id ?? prop('id', doc)
  const src = value.src ?? doc?.src ?? prop('src', doc)
  if (!documentId && !src) return null
  return {
    documentId: documentId ?? undefined,
    src: src ?? undefined,
    name: value.name ?? undefined
  }
}

export const useLoggedUserSignature = () => {
  const loggedUser = useLoggedUser()
  const loggedUserId = loggedUser?.id ?? null

  const { data } = useQuery(QUERY, {
    variables: {
      filter: {
        ids: loggedUserId ? [loggedUserId] : [],
        includeDisabled: true,
        ignoreSegments: true
      }
    },
    skip: !loggedUserId,
    client: accountsClient,
    fetchPolicy: 'cache-first'
  })

  const firstUser = path(['users', 0], data)
  const fieldValues = path(['contract', 'fieldValues'], firstUser) || []
  const signatureField = find(
    fv => SIGNATURE_FIELD_TYPES.includes(path(['field', 'type'], fv)),
    fieldValues
  )
  const rawValue = signatureField?.value
  const value = parseValue(rawValue)
  return normalizeSignatureValue(value)
}
